<template>
  <Question v-if="questionData" :quesData="questionData" />
</template>

<script>
import Question from "../Users/Patient/QA/Question"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const questions = RepositoryFactory.get("qa")

export default {
  name: "ShowSharedQuestion",
  data() {
    return { questionData: null }
  },
  components: { Question },
  mounted() {
    questions.searchQuestions("", "", 1, 1, this.currentCircle.id, this.$route.params.id).then(res => {
      this.questionData = res.data.data.data[0]
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/commons/ShareQUestion.vue